module.exports = __webpack_public_path__ + "img/1.4.5-1.17c637ad.jpg";